import Swal from "sweetalert2";

const state = {};

const mutations = {};

const actions = {
  success({commit, dispatch}, message) {
    this.$app.$notify({
      timeout: 2500,
      message: message,
      horizontalAlign: "right",
      verticalAlign: "top",
      icon: "add_alert",
      type: "success"
    });
  },
 
  error({commit, dispatch}, message) {
    this.$app.$notify({
      timeout: 2500,
      message: message,
      horizontalAlign: "right",
      verticalAlign: "top",
      icon: "add_alert",
      type: "warning"
    });
  },
  error_message({commit, dispatch}, data) {
    if(data && data.data){
        
    // console.log(data.data.errors)
    data.data.errors.forEach((dataError) => {
      var errorDetail = dataError.detail? "<br>" + dataError.detail : '';
      var message = "Error "+dataError.status+" : "+dataError.title + errorDetail;
      var message500 = "Error "+dataError.status+" : "+dataError.title;
      console.log(dataError.status)
      this.$app.$notify({
        timeout: 10500,
        message: (dataError.status == "500")?message500:message,
        horizontalAlign: "right",
        verticalAlign: "top",
        icon: (dataError.status == "500")?"error":"warning",
        type: (dataError.status == "500")?"danger":"warning"
      });
    });
    }
    else{
      this.$app.$notify({
        timeout: 10500,
        message: "Oops! Something went wrong",
        horizontalAlign: "right",
        verticalAlign: "top",
        icon: "error",
        type: "danger"
      });
    }
    
  }
};

const getters = {};

const alerts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default alerts;